import { Message } from "../../../domain/model/Auth";
import { CategoryEntity } from "../../../domain/model/Category";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { CategoryRepository } from "./CategoryRepository";

export class CategoryRepositoryImpl implements CategoryRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getCategories(): Promise<Response<Array<CategoryEntity>>> {
    return this.apiService.getCategories();
  }
}
